import { Component } from "@angular/core";
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { BreadcrumbModule } from "../../shared/components/breadcrumb/breadcrumb.module";
import { filter } from "rxjs";
import { CommonModule } from "@angular/common";

@Component({
  imports: [HeaderComponent, FooterComponent, RouterModule, BreadcrumbModule, CommonModule],
  templateUrl: "./main-layout.component.html",
  styleUrl: "./main-layout.component.scss",
})
export class MainLayoutComponent {}
